import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import FemaleSvg from './asset/female.svg'
import MaleSvg from './asset/male.svg'
import css from './GenderSelect.module.scss'

export const GenderSelect = observer(() => {
  const basic = store.profile.basic
  const gender = basic.gender
  const female = gender === 'female' && css.selected
  const male = gender === 'male' && css.selected

  const onFemale = useLatestCallback(() => basic.gender = 'female')
  const onMale = useLatestCallback(() => basic.gender = 'male')

  return (
    <Space gap={12}>
      <Vertical className={clsx(css.item, female)} onClick={onFemale}>
        <FemaleSvg />
        {i18n('Female')}
      </Vertical>
      <Vertical className={clsx(css.item, male)} onClick={onMale}>
        <MaleSvg />
        {i18n('Male')}
      </Vertical>
    </Space>
  )
})
